<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Profil">Profil Infrastruktur</a></li>
                                <li class="breadcrumb-item active">Pengaturan Profil Infrastruktur</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Profil Infrastruktur Tahun {{ secretencData }}
                                    </h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="card cardputih card-tabs">
                                        <div class="card-header p-0 pt-1">
                                            <ul class="nav nav-tabs justify-content-center" id="custom-tabs-four-tab"
                                                role="tablist" style="font-size: smaller;">
                                                <li class="nav-item" v-for="(datalist, urutlist) in datamaster"
                                                    :key="urutlist" @click="ambildatawilayah(datalist.KD_KAB)">
                                                    <a class="nav-link " :class="[urutlist == 0 ? 'active' : '']"
                                                        :id="'custom-tabs-four-home-tab' + datalist.id"
                                                        data-toggle="pill"
                                                        :href="'#custom-tabs-four-home' + datalist.id" role="tab"
                                                        :aria-controls="'custom-tabs-four-home' + datalist.id"
                                                        aria-selected="true">
                                                        ({{ datalist.KD_KAB }}) - {{ datalist.NAMA }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="card-body">
                                            <div class="tab-content" id="custom-tabs-four-tabContent">
                                                <template v-for="(datalist, urutlist) in data" :key="urutlist">
                                                    <div class="tab-pane fade "
                                                        :class="[urutlist == 0 ? 'show active' : '']"
                                                        :id="'custom-tabs-four-home' + datalist.id" role="tabpanel"
                                                        :aria-labelledby="'custom-tabs-four-home-tab' + datalist.id">
                                                        {{ datalist.NAMA }}<br><br>
                                                        <div class="panel-group" id="accordion">
                                                            <div class="panel panel-default"
                                                                v-for="(data, urutdata) in datalist.dataurusan"
                                                                :key="urutdata">
                                                                <div class="panel-heading" style="padding-top: 5px;padding-left: 10px;
                                                                    padding-bottom: 1px;font-size: smaller;"
                                                                    :style="'background-color:' + data.warna">
                                                                    <h5 class="panel-title" data-toggle="collapse"
                                                                        :data-target="'#collapse1' + data.id"
                                                                        style="cursor:pointer;font-size: small;">
                                                                        <a data-toggle="collapse"
                                                                            data-parent="#accordion"
                                                                            :href="'#collapse1' + data.id"
                                                                            style="color:#111;"> {{ urutdata + 1 }}.
                                                                            {{ data.namaurusan }} </a>
                                                                    </h5>
                                                                </div>
                                                                <div :id="'collapse1' + data.id"
                                                                    class="panel-collapse collapse"
                                                                    style="font-size: medium;">
                                                                    <div class="row"
                                                                        v-for="(isi, urutisi) in data.analisa"
                                                                        :key="urutisi">
                                                                        <div class="col-sm-12"
                                                                            :style="[isi.id == 0 ? 'display: none' : '']">
                                                                            <label style="font-size: small;">{{
                                                                                isi.tuliskolom }}</label>
                                                                            <input type="number"
                                                                                :id="'isian' + data.id + '_' + urutisi"
                                                                                class="form-control form-control-sm"
                                                                                :value="isi.persen"
                                                                                @change="updateisian(datalist.KD_KAB, secretencData, data.id, 'isian' + data.id + '_' + urutisi, 'simfast_analisa', isi.kolom)">
                                                                            <input type="hidden"
                                                                                :id="'kolom' + data.id + '_' + urutisi"
                                                                                class="form-control form-control-sm"
                                                                                :value="isi.kolom">
                                                                        </div>
                                                                        <div class="col-sm-12" style="font-size: small;"
                                                                            :style="[isi.id == 0 ? 'display: none' : '']">
                                                                            <label>Sumber Data {{ isi.tuliskolom
                                                                                }}</label>
                                                                            <input type="text"
                                                                                :id="'sumber' + data.id + '_' + urutisi"
                                                                                class="form-control form-control-sm"
                                                                                :value="isi.sumber"
                                                                                @change="updateisian(datalist.KD_KAB, secretencData, data.id, 'sumber' + data.id + '_' + urutisi, 'simfast_analisa', 'sumber_'+isi.kolom)">
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12">&nbsp;</div>
                                                                    <div class="row"
                                                                        v-for="(isidata, urutisidata) in data.data"
                                                                        :key="urutisidata">
                                                                        <div class="col-sm-12">
                                                                            <label style="font-size: small;">Konten Data
                                                                                {{ data.namaurusan }}</label>
                                                                            <editor v-model="isidata.isian"
                                                                                :id="'konten' + data.id + '_' + urutisidata"
                                                                                api-key="wy8pg36mgjka41li2j6w5vfjn0x4ufc4ss5xqt96n4dxb42a"
                                                                                :init="{
                                                                                    height: 500,
                                                                                    menubar: true,
                                                                                    plugins: [
                                                                                        'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks',
                                                                                        'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'wordcount'
                                                                                    ],
                                                                                    toolbar:
                                                                                        'undo redo | formatpainter casechange blocks | bold italic backcolor | ' +
                                                                                        'alignleft aligncenter alignright alignjustify | ' +
                                                                                        'bullist numlist checklist outdent indent | removeformat | a11ycheck code table help'
                                                                                }" />
                                                                        </div>
                                                                        <div class="col-sm-12 text-center">&nbsp;</div>
                                                                        <div class="col-sm-12 text-center">
                                                                            <button type="button"
                                                                                class="btn btn-sm btn-success3 text-white lebar2"
                                                                                v-if="(secretencData != 'Tambah')"
                                                                                @click="updatekonten(datalist.KD_KAB, secretencData, data.id, 'konten' + data.id + '_' + urutisidata, 'simfast_tema_pembangunan')"
                                                                                data-toggle="tooltip"
                                                                                data-placement="left"
                                                                                title="Update data.."><i
                                                                                    class="fa fa-check-circle"></i>
                                                                                Update Konten Data</button>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        &nbsp;
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 float-left pb-2">&nbsp;</div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Kembali</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">&nbsp;</div>
        <div class="container-fluid">&nbsp;</div>
        <Footer />
    </div>
</template>

<script>
import $, { data } from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import SummernoteEditor from 'vue3-summernote-editor';
import Editor from '@tinymce/tinymce-vue'
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor, Editor, SummernoteEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            datapesan: '',
            datamaster: [],
            data: [],
            datajumlahurusan: [],
            validasi: false,
        }
    },
    methods: {
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        batalproses() {
            window.location.replace("/Profil");
        },
        async ambildatawilayah(kodewilayah) {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovation_profilinf-GetProfilByTahun?tahun=" + this.secretencData + "&random=" + random + "&KD_KAB=" + kodewilayah).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datajumlahurusan = [];
                        this.datamaster = [];
                        this.data = [];
                        this.datajumlahurusan = Response.data.content.masterurusan;
                        this.datamaster = Response.data.content.master;
                        this.data = Response.data.content.data;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovation_profilinf-GetProfilByTahun?tahun=" + this.secretencData + "&random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datajumlahurusan = [];
                        this.datamaster = [];
                        this.data = [];
                        this.datajumlahurusan = Response.data.content.masterurusan;
                        this.datamaster = Response.data.content.master;
                        this.data = Response.data.content.data;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datajumlahurusan = [];
                this.datamaster = [];
                this.data = [];
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        updateisian(kodekab, tahun, urusan, id, tabel, kolom) {
            var myContent = document.getElementById(id).value;
            var fd = new FormData();
            fd.append("kodekab", kodekab);
            fd.append("tahun", tahun);
            fd.append("urusan", urusan);
            fd.append("id", id);
            fd.append("tabel", tabel);
            fd.append("kolom", kolom);
            fd.append("konten", myContent);
            fd.append("updateby", JSON.parse(localStorage.getItem("usistem")));
            //console.log(JSON.parse(localStorage.getItem("usistem")));
            //return false;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_profilinf-UpdateIsian", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'error',
                            title: Response.data.message,
                        });
                        return false;
                    }
                    else {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: 'Data telah diupdate',
                        });
                        return false;
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
        updatekonten(kodekab, tahun, urusan, id, tabel) {
            var myContent = tinymce.get(id).getContent();
            //return false;
            var fd = new FormData();
            fd.append("kodekab", kodekab);
            fd.append("tahun", tahun);
            fd.append("urusan", urusan);
            fd.append("id", id);
            fd.append("tabel", tabel);
            fd.append("konten", myContent);
            fd.append("updateby", JSON.parse(localStorage.getItem("usistem")));
            //console.log(JSON.parse(localStorage.getItem("usistem")));
            //return false;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_profilinf-UpdateProfil", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.reload();
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
    }
}
</script>
<style></style>